var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoTableNotUserAError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 62",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M17 36h-5.997a2.5 2.5 0 0 1-2.5-2.5v-15a2.5 2.5 0 0 1 2.5-2.5H37L17 36Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M19.003 34 35 18H11.003a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h8Zm-8-18a2.5 2.5 0 0 0-2.5 2.5v15a2.5 2.5 0 0 0 2.5 2.5H17l20-20H11.003Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M44 26h4.997a2.5 2.5 0 0 1 2.5 2.5v15a2.5 2.5 0 0 1-2.5 2.5H24l20-20Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M42 28 26 44h22.997a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5H42Zm6.997 18a2.5 2.5 0 0 0 2.5-2.5v-15a2.5 2.5 0 0 0-2.5-2.5H44L26 44l-2 2h24.997Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M12 3h10l.752 8.274A2.5 2.5 0 0 1 20.262 14h-6.524a2.5 2.5 0 0 1-2.49-2.726L12 3Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m11 5 .223-.445A2.813 2.813 0 0 1 13.738 3h6.524c1.065 0 2.039.602 2.515 1.555L23 5"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M48 59H38l-.752-8.274A2.5 2.5 0 0 1 39.738 48h6.524a2.5 2.5 0 0 1 2.49 2.726L48 59Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m49 57-.223.445A2.813 2.813 0 0 1 46.262 59h-6.524a2.813 2.813 0 0 1-2.515-1.555L37 57M5 56.586 56.586 5"
})));
SvgNoTableNotUserAError.viewBox = '0 0 60 62';
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoTableNotUserAError);
export default ForwardRef;